<template>
	<div class="content-box" v-loading="loadings.main">
		<el-form
				class="row"
				ref="editorForm"
				:model="editorForm"
				:rules="rules"
				status-icon
				label-position="left"
				label-width="120px"
				size="mini"
				v-loading="loadings.main"
				@submit.native.prevent
		>
			<div class="col-md-4">
				<el-form-item label="姓名" prop="name" :error="err.name">
					<el-input type="text" placeholder="姓名" v-model="editorForm.name"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="phone" :error="err.phone">
					<el-input type="text" placeholder="手机号" v-model="editorForm.phone"></el-input>
				</el-form-item>
				<el-button size="mini" type="primary" @click="onSubmit('editorForm')">确 定</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>

export default {
	data() {
		return {
			info: {},
			editorFields: [
				{
					name: "name",
					col: 12
				},
				{
					name: "phone",
					col: 12
				}
			],
			editorForm: {
				name: "",
				phone: "",
			},
			err: {
				name: "",
				phone: "",
			},
			rules: {
				name: [
						{
							required: true,
							message: "请输入姓名",
							trigger: "blur"
						}
				],
				phone: [
						{
							required: true,
							message: "请输入手机号",
							trigger: "blur"
						}
				]
			},
			loadings: {
				main: false
			},
			hasGetData: false
		};
	},
	computed: {},
	created() {},
	mounted() {
		this.refreshData();
	},
	methods: {
		refreshData() {
			this.loadings.main = true;
			this.$axios
				.post(`/admin/info/`)
				.then(json => {
					this.loadings.main = false;
					for (let k in json.data.info) {
						this.$set(this.info, k, json.data.info[k]);
					}
					this.hasGetData = true;
				})
				.catch(json => {
					this.loadings.main = false;
				});
		},
		onSubmit(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loadings.main = true;
					this.$axios
							.post("/admin/do_edit_info/", this.editorForm)
							.then(json => {
								this.$message({
									type: "success",
									message: "成功!"
								});
								this.loadings.main = false;
							})
							.catch(json => {
								this.loadings.main = false;
								if (this.err[json.data.field]) {
									this.err[json.data.field] = json.data.msg;
								}
								this.$message({
									message: json.data.msg,
									type: "error"
								});
							});
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}
	},
	watch: {},
};
</script>
<style lang="scss" scoped>
</style>
